import { defineComponent as m, openBlock as t, createElementBlock as o, mergeProps as d, unref as e, renderSlot as i, createElementVNode as n, createCommentVNode as p } from "vue";
import { useScalarIcon as Z } from "../hooks/useScalarIcon.js";
const u = { key: 0 }, g = { key: 1 }, f = { key: 2 }, k = { key: 3 }, M = { key: 4 }, w = { key: 5 }, y = {
  name: "ScalarIconLinkSimpleHorizontal"
}, S = /* @__PURE__ */ m({
  ...y,
  props: {
    label: {},
    weight: {}
  },
  setup(l) {
    const H = l, { bind: r, weight: h } = Z(H);
    return (s, a) => (t(), o("svg", d({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(r)), [
      i(s.$slots, "default"),
      e(h) === "bold" ? (t(), o("g", u, a[0] || (a[0] = [
        n("path", { d: "M80,116h96a12,12,0,0,1,0,24H80a12,12,0,0,1,0-24Zm24,48H64a36,36,0,0,1,0-72h40a12,12,0,0,0,0-24H64a60,60,0,0,0,0,120h40a12,12,0,0,0,0-24Zm88-96H152a12,12,0,0,0,0,24h40a36,36,0,0,1,0,72H152a12,12,0,0,0,0,24h40a60,60,0,0,0,0-120Z" }, null, -1)
      ]))) : e(h) === "duotone" ? (t(), o("g", g, a[1] || (a[1] = [
        n("path", {
          d: "M240,128h0a48,48,0,0,1-48,48H64a48,48,0,0,1-48-48h0A48,48,0,0,1,64,80H192A48,48,0,0,1,240,128Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M80,120h96a8,8,0,0,1,0,16H80a8,8,0,0,1,0-16Zm24,48H64a40,40,0,0,1,0-80h40a8,8,0,0,0,0-16H64a56,56,0,0,0,0,112h40a8,8,0,0,0,0-16Zm88-96H152a8,8,0,0,0,0,16h40a40,40,0,0,1,0,80H152a8,8,0,0,0,0,16h40a56,56,0,0,0,0-112Z" }, null, -1)
      ]))) : e(h) === "fill" ? (t(), o("g", f, a[2] || (a[2] = [
        n("path", { d: "M224,48H32A16,16,0,0,0,16,64V192a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V64A16,16,0,0,0,224,48ZM112,168H80a40,40,0,0,1,0-80h32a8,8,0,0,1,0,16H80a24,24,0,0,0,0,48h32a8,8,0,0,1,0,16Zm48-48a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16Zm16,48H144a8,8,0,0,1,0-16h32a24,24,0,0,0,0-48H144a8,8,0,0,1,0-16h32a40,40,0,0,1,0,80Z" }, null, -1)
      ]))) : e(h) === "light" ? (t(), o("g", k, a[3] || (a[3] = [
        n("path", { d: "M80,122h96a6,6,0,0,1,0,12H80a6,6,0,0,1,0-12Zm24,48H64a42,42,0,0,1,0-84h40a6,6,0,0,0,0-12H64a54,54,0,0,0,0,108h40a6,6,0,0,0,0-12Zm88-96H152a6,6,0,0,0,0,12h40a42,42,0,0,1,0,84H152a6,6,0,0,0,0,12h40a54,54,0,0,0,0-108Z" }, null, -1)
      ]))) : e(h) === "regular" ? (t(), o("g", M, a[4] || (a[4] = [
        n("path", { d: "M80,120h96a8,8,0,0,1,0,16H80a8,8,0,0,1,0-16Zm24,48H64a40,40,0,0,1,0-80h40a8,8,0,0,0,0-16H64a56,56,0,0,0,0,112h40a8,8,0,0,0,0-16Zm88-96H152a8,8,0,0,0,0,16h40a40,40,0,0,1,0,80H152a8,8,0,0,0,0,16h40a56,56,0,0,0,0-112Z" }, null, -1)
      ]))) : e(h) === "thin" ? (t(), o("g", w, a[5] || (a[5] = [
        n("path", { d: "M80,124h96a4,4,0,0,1,0,8H80a4,4,0,0,1,0-8Zm24,48H64a44,44,0,0,1,0-88h40a4,4,0,0,0,0-8H64a52,52,0,0,0,0,104h40a4,4,0,0,0,0-8Zm88-96H152a4,4,0,0,0,0,8h40a44,44,0,0,1,0,88H152a4,4,0,0,0,0,8h40a52,52,0,0,0,0-104Z" }, null, -1)
      ]))) : p("", !0)
    ], 16));
  }
});
export {
  S as default
};
